/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2020, Zumper
 */

export const CLEAR_LISTABLES = '@@nzr/relatedListings/CLEAR_LISTABLES'
export const ERROR_FETCHING = '@@nzr/relatedListings/ERROR_FETCHING'
export const RECEIVE_LISTABLES = '@@nzr/relatedListings/RECEIVE_LISTABLES'
